import React, { lazy } from "react";

const LazyFiles = lazy(() => import("./TeamFiles"));

const TeamFiles = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => <LazyFiles {...props} />;

export default TeamFiles;
